var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"icon-right":"play-circle-outline"},on:{"click":_vm.playAudio}},[_c('span',{staticClass:"is-size-7"},[_vm._v(_vm._s(_vm.options.filename))]),_vm._v(" · "+_vm._s(_vm.options.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }